(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["age-gate"] && !Shopify.designMode) return;
  try {
    (() => {
  const gate = document.getElementById('FeitoriaAgeGate');
  if (!gate) return;
  const root = document.documentElement;
  const required = gate.dataset.required === 'true';
  const persistentKey = 'feitoria_age_confirmation_v1';
  const sessionKey = 'feitoria_age_session_v1';
  const duration = 30 * 24 * 60 * 60 * 1000;
  const question = gate.querySelector('[data-age-question]');
  const denied = gate.querySelector('[data-age-denied]');
  const remember = gate.querySelector('[data-age-remember]');
  let acceptedHere = false;
  let previousFocus = null;
  let locked = [];
  const storage = (kind, action, key, value) => {
    try { return window[kind][action](key, value); } catch (_) { return null; }
  };
  const forget = () => {
    storage('localStorage', 'removeItem', persistentKey);
    storage('sessionStorage', 'removeItem', sessionKey);
    acceptedHere = false;
  };
  const hasConfirmation = () => {
    try {
      const value = JSON.parse(storage('localStorage', 'getItem', persistentKey) || 'null');
      if (value && value.confirmed === true && Number.isFinite(value.expiresAt) && value.expiresAt > Date.now() && value.expiresAt <= Date.now() + duration) return true;
      storage('localStorage', 'removeItem', persistentKey);
    } catch (_) { storage('localStorage', 'removeItem', persistentKey); }
    return storage('sessionStorage', 'getItem', sessionKey) === 'yes';
  };
  const unlock = () => {
    locked.forEach(([element, wasInert]) => { element.inert = wasInert; });
    locked = [];
    root.classList.remove('fs-age-pending');
  };
  const close = (restoreFocus) => {
    if (typeof gate.close === 'function') gate.close();
    else gate.removeAttribute('open');
    unlock();
    if (restoreFocus) {
      const target = previousFocus && previousFocus !== document.body ? previousFocus : document.getElementById('MainContent');
      if (target) target.focus({preventScroll:true});
    }
  };
  const showQuestion = () => {
    question.hidden = false;
    denied.hidden = true;
    gate.setAttribute('aria-labelledby', 'AgeGateTitle');
    gate.setAttribute('aria-describedby', 'AgeGateIntro');
    document.getElementById('AgeGateTitle').focus({preventScroll:true});
  };
  const open = () => {
    remember.checked = false;
    if (!gate.open) previousFocus = document.activeElement;
    root.classList.add('fs-age-pending');
    if (!locked.length) {
      Array.from(document.body.children).filter(element => element !== gate && !['SCRIPT','STYLE','LINK'].includes(element.tagName)).forEach(element => {
        locked.push([element, element.inert]);
        element.inert = true;
      });
    }
    if (gate.open && typeof gate.close === 'function') gate.close();
    if (typeof gate.showModal === 'function') gate.showModal();
    else gate.setAttribute('open', '');
    showQuestion();
  };
  gate.querySelectorAll('button').forEach(button => { button.disabled = false; });
  gate.addEventListener('cancel', event => event.preventDefault());
  gate.addEventListener('keydown', event => {
    if (event.key === 'Escape') event.preventDefault();
    if (event.key !== 'Tab') return;
    const elements = Array.from(gate.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled)')).filter(element => element.getClientRects().length);
    const first = elements[0], last = elements[elements.length - 1];
    if (!first) return;
    if (event.shiftKey && (document.activeElement === first || !elements.includes(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !elements.includes(document.activeElement))) { event.preventDefault(); first.focus(); }
  });
  gate.querySelector('[data-age-yes]').addEventListener('click', () => {
    forget();
    acceptedHere = true;
    if (remember.checked) {
      storage('localStorage', 'setItem', persistentKey, JSON.stringify({confirmed:true,expiresAt:Date.now() + duration}));
      if (!hasConfirmation()) storage('sessionStorage', 'setItem', sessionKey, 'yes');
    } else storage('sessionStorage', 'setItem', sessionKey, 'yes');
    acceptedHere = !hasConfirmation();
    close(true);
  });
  gate.querySelector('[data-age-no]').addEventListener('click', () => {
    forget();
    remember.checked = false;
    question.hidden = true;
    denied.hidden = false;
    gate.setAttribute('aria-labelledby', 'AgeGateDeniedTitle');
    gate.setAttribute('aria-describedby', 'AgeGateDeniedText');
    document.getElementById('AgeGateDeniedTitle').focus({preventScroll:true});
  });
  gate.querySelector('[data-age-back]').addEventListener('click', showQuestion);
  document.querySelectorAll('[data-age-reset]').forEach(button => {
    button.hidden = false;
    button.addEventListener('click', () => { forget(); remember.checked = false; open(); });
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted && required && !acceptedHere && !hasConfirmation()) open();
  });
  window.addEventListener('storage', event => {
    if (event.key !== persistentKey && event.key !== null) return;
    if (!hasConfirmation()) {
      acceptedHere = false;
      if (required) open();
    }
  });
  if (required && !hasConfirmation()) open();
  else close(false);
})();
  } catch(e) { console.error(e); }
})();

})();
